"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Namespace for dom interactions w/ related links & addtess item
 * in marginal column
 *
 * @namespace
 * @memberOf txGs1Base.content
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.content.datepicker = {
    datepickerFields: $('.form-date-picker.date input'),
    /**
     * attach function
     *
     * @namespace
     * @memberOf txGs1Base.content.datepicker
     * @public
     */
    attach: function () {
        _main_1.txGs1Base.content.datepicker.datepickerFields.datepicker({
            format: "dd.mm.yyyy",
            language: "de"
        });
    },
    /**
     * init function
     *
     * @namespace
     * @memberOf txGs1Base.content.datepicker
     * @public
     */
    initialize: function () {
        _main_1.txGs1Base.content.datepicker.attach();
    }
};
exports.default = {};
